// Kleine Helfer für Datum, Text und DOM.

/** Rechnungsnummer mit genau einem «#» (MILKEE liefert sie schon mit «#») */
export const invNr = (n: string | null | undefined) => (n ? `#${String(n).replace(/^#+/, "")}` : "");
export const DAY = 864e5;
export const WD = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];
export const WDL = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
export const MON = ["Jan.", "Feb.", "März", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."];
export const MONS = ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"];
export const MONL = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];

export const pad = (n: number) => String(n).padStart(2, "0");
export const uid = () => {
  const b = new Uint8Array(6);
  crypto.getRandomValues(b);
  return Array.from(b, (x) => x.toString(36).padStart(2, "0")).join("").slice(0, 10);
};

const ESC: Record<string, string> = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" };
export const esc = (s: unknown) => String(s ?? "").replace(/[&<>"']/g, (c) => ESC[c] ?? c);

export const today0 = () => {
  const t = new Date();
  t.setHours(0, 0, 0, 0);
  return t;
};
export const daysFrom = (iso: string) => {
  const t = new Date(iso);
  t.setHours(0, 0, 0, 0);
  return Math.round((t.getTime() - today0().getTime()) / DAY);
};
export const fmtD = (iso: string) => {
  const d = new Date(iso);
  return `${WD[d.getDay()]}, ${d.getDate()}. ${MON[d.getMonth()]}`;
};
export const fmtDate = (iso: string | null | undefined) => {
  if (!iso) return "–";
  const d = new Date(iso);
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`;
};
export const toInput = (iso: string | null | undefined) => {
  if (!iso) return "";
  const d = new Date(iso);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};
export const fromInput = (v: string) => (v ? new Date(`${v}T12:00`).toISOString() : null);
export const nowIso = () => new Date().toISOString();

export function rel(n: number): string {
  if (n < -1) return `${-n} Tage überfällig`;
  if (n === -1) return "seit gestern fällig";
  if (n === 0) return "heute";
  if (n === 1) return "morgen";
  if (n < 14) return `in ${n} Tagen`;
  return `in ${Math.round(n / 7)} Wochen`;
}
export const relCls = (n: number) => (n < 0 ? "bad" : n <= 2 ? "warn" : n <= 7 ? "acc" : "");

export const hostOf = (u: string) => {
  try {
    return new URL(u).hostname.replace(/^www\./, "");
  } catch {
    return u;
  }
};
export const safeUrl = (u: string) => (/^https?:\/\//i.test(u) ? u : `https://${u}`);

/* ---------- DOM ---------- */

export const byId = <T extends HTMLElement = HTMLElement>(id: string) => document.getElementById(id) as T | null;
export const must = <T extends HTMLElement = HTMLElement>(id: string) => {
  const el = document.getElementById(id);
  if (!el) throw new Error(`#${id} fehlt`);
  return el as T;
};
/** Wert eines Eingabefelds, getrimmt. Leerer Text, wenn das Feld fehlt. */
export const val = (id: string) => (byId<HTMLInputElement>(id)?.value ?? "").trim();
/** Wert ohne Trimmen (Passwörter). */
export const rawVal = (id: string) => byId<HTMLInputElement>(id)?.value ?? "";

/** Sensibler Wert (z. B. Betrag): im Privatmodus unscharf. Eigenes Element, damit Regeln für «span» (z. B. kleine Beschriftungen) nicht greifen. */
export const sens = (s: string) => `<x-sens>${s}</x-sens>`;
